import { DataVizConfig } from "./dataVizConfig.js";

/**
 * @typedef {Object} TopicDataVizConfigSpecificParams
 * @property {string} customText - text to display
 */
/**
 * @typedef {TopicDataVizConfigSpecificParams & import("./dataVizConfig.js").DataVizConfigParams} TopicDataVizConfigParams
 */
export class TopicDataVizConfig extends DataVizConfig {
  /**
   * @constructor
   * @param {TopicDataVizConfigParams} args
   */
  constructor({ customText, ...rest }) {
    super({ ...rest });
    this._customText = customText;
  }

  get customText() {
    return this._customText;
  }

  set customText(newCustomText) {
    this._customText = newCustomText;
  }
}
